<form [formGroup]="advancedSearchForm" style="margin-bottom: 3rem;">
  <div class="club-section">
    <p class="esf-heading esf-heading--data" i18n='Section heading@@general.sectionHeading.clubData' style="margin-top: 10px; margin-bottom: 15px;">Club data</p>
    <div app-form-field-text-generic
         [control]="advancedSearchForm.controls['externalNumber']"
         [placeholder]="flTranslations.i18nCustomerNumber"
         [label]="flTranslations.i18nCustomerNumber">
    </div>

    <div class="esf-form-group">
      <div app-form-field-text-generic
           [control]="advancedSearchForm.controls['invoiceNumber']"
           [placeholder]="flTranslations.i18nTixxInvoiceNumber"
           [label]="flTranslations.i18nTixxInvoiceNumber">
      </div>
      <div app-form-field-text-generic
           [control]="advancedSearchForm.controls['membershipNumber']"
           [placeholder]="flTranslations.i18nMembershipNumber"
           [label]="flTranslations.i18nMembershipNumber">
      </div>
    </div>

  </div>
  <div class="personal-section">
    <p class="esf-heading esf-heading--data" i18n='Data heading@@general.sectionHeading.personalData' style="margin-top: 10px; margin-bottom: 15px;">Personal data</p>
    <div app-form-field-text-generic
         [control]="advancedSearchForm.controls['company']"
         [placeholder]="flTranslations.i18nCompany"
         [label]="flTranslations.i18nCompany">
    </div>

    <div class="esf-form-group">
      <div app-form-field-text-generic
           [control]="advancedSearchForm.controls['firstName']"
           [placeholder]="flTranslations.i18nFirstName"
           [label]="flTranslations.i18nFirstName">
      </div>
      <div app-form-field-text-generic
           [control]="advancedSearchForm.controls['lastName']"
           [placeholder]="flTranslations.i18nLastName"
           [label]="flTranslations.i18nLastName">
      </div>
    </div>

    <div app-form-field-datepicker
         [past]="true"
         [control]="advancedSearchForm.controls['birthday']"
         [placeholder]="flTranslations.i18nBirthday"
         [label]="flTranslations.i18nBirthday">
    </div>
  </div>
  <div class="communication-section">
    <p class="esf-heading esf-heading--data" i18n='Data heading@@general.sectionHeading.communicationData'
       style="margin-top: 10px; margin-bottom: 15px;">Comunication data</p>

    <div app-form-field-text-generic
         [control]="advancedSearchForm.controls['email']"
         [placeholder]="flTranslations.i18nEmail"
         [label]="flTranslations.i18nEmail">
    </div>
  </div>
  <div class="address-section">
    <p class="esf-heading esf-heading--data" i18n='Data heading@@general.sectionHeading.addressData' style="margin-top: 10px; margin-bottom: 15px;">Address data</p>

    <div class="esf-form-group">
      <div app-form-field-text-generic
           [control]="advancedSearchForm.controls['street']"
           [placeholder]="flTranslations.i18nStreet"
           [label]="flTranslations.i18nStreet">
      </div>
      <div app-form-field-text-generic
           [control]="advancedSearchForm.controls['postalCode']"
           [placeholder]="flTranslations.i18nPostCode"
           [label]="flTranslations.i18nPostCode">
      </div>
    </div>

    <div class="esf-form-group">
      <div app-form-field-text-generic
           [control]="advancedSearchForm.controls['city']"
           [placeholder]="flTranslations.i18nCity"
           [label]="flTranslations.i18nCity">
      </div>
      <div app-form-field-select
           [control]="advancedSearchForm.controls['country']"
           [label]="flTranslations.i18nCountry"
           [valueKey]="'iso2'"
           [textKey]="'name'"
           [array]="countries">
      </div>
    </div>

    <!-- <div class="esf-form-group">
        <div class="esf-form-item esf-form-item--1-2">
          <label class="esf-form-item__label" i18n='Form label for input box@@general.formLabel.country' for="country">Country</label>
          <div class="esf-select">
            <select class="esf-form-item__field esf-select__field selected-field" formnumber=12 id="country" formControlName="country"
                    (keydown)="keyDown($event)">
              <option i18n="Form placeholder@@general.formPlaceholder.selectCountry" [value]="null" disabled selected>Select country</option>
              <option *ngFor="let country of countries" [value]="country.iso2">{{ country.name }}</option>
            </select>
          </div>
        </div>
      </div> -->

  </div>

  <div class="esf-submit-row">
    <div class="esf-submit-row__item">
      <button class="esf-button esf-button--standard esf-button--filled" (click)="onSubmit()" type="submit" [disabled]="!atLeastOneField">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-search"></use>
        </svg>
        <span i18n='@@general.button.search' class="esf-button__icon-text">Search</span>
      </button>
    </div>
    <div class="esf-submit-row__item">
      <button class="esf-button esf-button--standard esf-button--outlined" type="button" (click)="clearAdvancedSearchValues()">
        <span i18n='@@general.button.reset'>Reset</span>
      </button>
    </div>
  </div>
</form>
